import * as shared from "@/styles/shared";
import { SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./NotFoundPage.styles";

const NotFoundPage = () => {
  const { t } = useTranslation("notFound");
  return (
    <div className={shared.centerScreen}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <SearchX className={styles.icon} />
        </div>
        <h1 className={styles.errorCode}>{t("errorCode")}</h1>
        <p className={styles.errorMessage}>{t("errorMessage")}</p>
        <a href="/dashboard" className={styles.dashboardLink}>
          {t("goToDashboard")}
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
